/**
 * `/contact` and `/book`.
 *
 * `/contact` is the POST target for every form on the site and must not move.
 * It stays linked from both the primary navigation and every footer.
 *
 * NOTHING HERE MAY PROMISE A CONFIRMED APPOINTMENT. Cal.com is the live
 * scheduler; the contact form posts to `/contact` and a human replies, but it
 * does not hold a time. Banned verbs for the contact path: Book, Reserve,
 * Confirm your time, Pick a slot. A phone number is a real capability; a
 * booked time is not.
 *
 * The confirmation makes no turnaround promise. The controller's flash used to
 * say "within 24 hours" and nobody has measured that.
 */
export const contact = {
  hero: {
    line1: "Contact us",
    line2: "and get a direct answer",
    intro:
      "Ask about a bike, a test ride, service for a bike purchased here, or Colorado savings. Call during shop hours or send a message anytime.",
  },

  fields: {
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone (optional)",
    topic: "What's this about?",
    message: "Your message",
  },
  topicPlaceholder: "Pick one",
  topics: [
    { value: "test-ride", label: "A test ride" },
    { value: "sales", label: "A bike on the floor" },
    { value: "service", label: "Service or repair" },
    { value: "newsletter", label: "Newsletter updates" },
    { value: "other", label: "Something else" },
  ],
  newsletterRequest: "Please add me to occasional shop updates.",
  submit: "Send message",
  submitting: "Sending…",
  formNote: "Your message goes directly to the shop.",
  sentHeading: "Message sent.",
  sentBody: "The shop received your message and will reply by email or phone.",

  asideHeading: "Prefer to call?",
  asideBody: "Call during open hours for the fastest answer.",

  book: {
    line1: "Find the right family bike",
    line2: "on a real test ride",
    intro:
      "Choose a time, tell us which bikes you want to compare, and bring the people or gear you normally carry. The ride is free and there is no purchase required.",
    /**
     * The honest disclosure. This page is not a scheduler and must never look
     * like one — no calendar, no time slots, no confirmation. Deleting this
     * paragraph would make the page lie.
     */
    /*
      COUPLED TO booking.ts's BOOKING_ENABLED, which is now TRUE.

      These strings replaced "There's no booking system here, on purpose" on
      2026-08-18, in the same commit that turned the Cal.com embed on. That
      sentence was true for months and became false the moment a working
      calendar appeared above it.

      What may NOT be said here: that a slot is confirmed, held or reserved.
      Cal.com confirms in its own UI and by email; this page's job is to send
      people there and to keep the walk-in door open. script/booking_check.mjs
      fails the build if this page ever promises a confirmation, or if it goes
      back to denying the scheduler while the calendar is live.
    */
    noBookingHeading: "Appointments and walk-ins",
    noBookingBody:
      "Scheduling helps us prepare the bikes you want to compare. Walk-ins are also welcome during open hours.",
    scheduleHeading: "Schedule your test ride",
    scheduleBlurb:
      "We reserve 45 minutes so there is time to set up the bike, ride for about 30 minutes, and ask questions.",
    fallbackScheduleBlurb:
      "Choose a free 30-minute test ride in the calendar and add the bikes you want to compare in the booking notes.",

    factsHeading: "What to expect",
    facts: [
      "Free · 45-minute appointment · about 30 minutes riding",
      "The creek path starts right behind the shop",
      "Bring the children or gear you plan to carry.",
      "Bring helmets for everyone riding. Closed-toe shoes, gloves, and glasses are recommended.",
      "Tue–Sat, 10am–6pm. Closed Sun–Mon",
    ],
    fallbackFacts: [
      "Free · 30-minute test ride · no purchase required",
      "The creek path starts right behind the shop",
      "Bring the children or gear you plan to carry.",
      "Bring helmets for everyone riding. Closed-toe shoes, gloves, and glasses are recommended.",
      "Tue–Sat, 10am–6pm. Closed Sun–Mon",
    ],
  },
} as const;
